import React from 'react';

import { useTranslation } from '@external/react-i18next';

const CandidateProgressTable: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <h4 className="text-gray-600">
        {t('mml.club-candidate-progress', 'PROGRESS HISTORY')}
      </h4>
      <div className="flex items-center relative px-8 tablet:px-5 tablet:bg-gray-100  bg-gray-100 px-5 justify-between border-t-3 border-gray-300">
        <div className="flex flex-row w-full items-center h-full mt-4 mb-4">
          <div className="w-20 mr-auto self-center flex-auto">
            <p className="font-sans text-gray-400 text-sm leading-5 font-bold">
              {t('mml.club-candidate-date', 'Date')}
            </p>
          </div>
          <div className="relative right-15 w-20 mr-auto self-center flex-auto">
            <p className="font-sans text-gray-400 text-sm leading-5 font-bold">
              {t('mml.club-candidate-status', 'Status')}
            </p>
          </div>
          <div className="relative right-5 w-15 mr-auto self-center flex-auto">
            <p className="font-sans text-gray-400 text-sm leading-5 font-bold">
              {t('mml.club-candidate-club/district', 'District/Club')}
            </p>
          </div>
          <div className="relative right-5 w-15 mr-auto self-center flex-auto">
            <p className="font-sans text-gray-400 text-sm leading-5 font-bold">
              {t('mml.club-candidate-modified-by', 'Modified by')}
            </p>
          </div>
          <div className="w-40 mr-auto self-center flex-auto">
            <p className="font-sans text-gray-400 text-sm leading-5 font-bold">
              {t('mml.club-candidate-notes', 'Notes')}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateProgressTable;
